const IMG = "https://static.prod-images.emergentagent.com/jobs/c8af09b0-9b4f-455e-bd83-c9d2d31e64b5/images/";

export const HERO_IMG = `${IMG}5c157c91e8602faeb235d18eec65c27cfea6c2c4ed3df33c7cba1ef91cd4752a.jpeg`;

export const SERVICES = [
  {
    title: "Nettoyage en cours de chantier",
    text: "Passages quotidiens ou hebdomadaires pour un chantier sûr et ordonné.",
    img: `${IMG}b6179973bbb6a5215fe59da6d2d80c7efbecff412d6ff7768e516dddfeb8d3ed.jpeg`,
  },
  {
    title: "Débarras & évacuation",
    text: "Tri et évacuation conformes des déchets : bois, inertes, plastiques, métaux.",
    img: `${IMG}c3fc1ff3e694f5b1d3e91bbd19a7f06ac89494005676ba5fc98f534d78c1262b.jpeg`,
  },
  {
    title: "Fin de chantier",
    text: "Nettoyage complet avant la remise des clés à votre client.",
    img: `${IMG}c215405423a5858db2c526fd44dbcd5c590d3c2c2aee942062712f162b750ec2.jpeg`,
  },
  {
    title: "Bureaux & locaux",
    text: "Entretien régulier de bureaux, bungalows et ateliers.",
    img: `${IMG}a9a4a5e4c69d449344e89340c4ceaa0150eb4f10684f9705212db5938801156a.jpeg`,
  },
  {
    title: "Débarras de locaux",
    text: "Caves, dépôts, ateliers : vidés et propres.",
    img: `${IMG}3199978ee35b3c2cc4b5e80ee95ec296ecf92c985263fde013d89b2558c7e61c.jpeg`,
  },
  {
    title: "Rangement & organisation à domicile",
    text: "Désencombrement, tri, dressing, cuisine, cave : on range avec vous, sans jugement.",
    img: `${IMG}aecb71bdb9242c3454498294ec89d499c6d385a24648954e9b5e792a6fbcdfa4.jpeg`,
    href: "#rangement",
  },
];

export const RANGEMENT_SERVICE = "Rangement & organisation à domicile";
export const RANGEMENT_PHOTOS = [
  { src: `${IMG}aecb71bdb9242c3454498294ec89d499c6d385a24648954e9b5e792a6fbcdfa4.jpeg`, alt: "Salon rangé et lumineux après une séance de rangement" },
  { src: `${IMG}5a2b721f4a5b1e50cf0ee7b64bc77d1693fbb74f036845c16b93c01df5918d89.jpeg`, alt: "Dressing organisé par catégories" },
  { src: `${IMG}6f1429f7b0f5ce7ca6ed5c89da5a29f3ab5cbe4d891143c8e85d187a965b525f.jpeg`, alt: "Cuisine désencombrée et organisée" },
];
export const RANGEMENT_STEPS = [
  { title: "Appel ou visite gratuite", text: "Nous prenons le temps de comprendre vos besoins, vos habitudes et vos priorités." },
  { title: "Séance de tri et rangement", text: "Avec vous ou sans vous : on trie, on désencombre, on range pièce par pièce." },
  { title: "Une maison en ordre", text: "Des espaces clairs et faciles à vivre, plus nos conseils pour que ça dure." },
];
export const RANGEMENT_OFFERS = [
  { title: "Séance découverte 3 h", text: "Idéal pour une pièce, un dressing ou une cuisine. On commence ensemble et vous voyez la différence." },
  { title: "Journée complète", text: "Pour avancer vraiment : plusieurs pièces, cave ou garage, préparation d'un déménagement ou d'un emménagement." },
];
export const RANGEMENT_FAQ = [
  { q: "Dois-je être présent ?", a: "Comme vous préférez. Beaucoup de clients participent à la première séance pour décider de ce qu'ils gardent ; ensuite, nous pouvons travailler sans vous, selon vos consignes." },
  { q: "Que faites-vous des objets dont je me sépare ?", a: "Nous les trions avec vous : don à des associations, recyclage en déchetterie ou débarras complet grâce à notre service de débarras. Rien n'est jeté sans votre accord." },
  { q: "Et la confidentialité ?", a: "Discrétion totale : vos affaires, votre intérieur et vos informations restent privés. Nous intervenons avec bienveillance et sans jugement." },
];

export const WHY = [
  { title: "Issus du bâtiment", text: "Nous connaissons vos contraintes de chantier." },
  { title: "Réactifs", text: "Intervention sous 48 h, y compris en urgence." },
  { title: "Rentable pour vous", text: "Vos ouvriers qualifiés restent sur leur vrai travail." },
];

export const NAV = [
  { href: "#services", label: "Services" },
  { href: "#rangement", label: "Rangement" },
  { href: "#avant-apres", label: "Avant / Après" },
  { href: "#pourquoi-nous", label: "Pourquoi nous" },
  { href: "#contact", label: "Contact" },
];

export const BEFORE_AFTER = [
  {
    title: "Chantier en cours",
    caption: "Gravats, chutes et emballages évacués : un sol dégagé et sûr pour vos équipes.",
    before: `${IMG}641191a9a7763012797fcba68778dfe70b0401a9a9be1063c0130105cb95c039.jpeg`,
    after: `${IMG}cb53e380337ed4c57907a89bd9632fea27298e7cbe5eee596098e594ee29df51.jpeg`,
  },
  {
    title: "Fin de chantier",
    caption: "Poussière de plâtre, adhésifs et traces supprimés : l'appartement est prêt à livrer.",
    before: `${IMG}e414e489ff5ab7c70f0381798fa8464fe758f2575e6da43f199387ac0a2af2db.jpeg`,
    after: `${IMG}d257f1dbe9f8a5acfc791481e648d79965c7149d546aedc8f69cb7177a456017.jpeg`,
  },
  {
    title: "Débarras de local",
    caption: "Cave encombrée vidée, déchets triés et évacués, sol balayé.",
    before: `${IMG}2fb3bf541c765aff1b8a122268e30290d9a678a3b4962355065e31ffe582a546.jpeg`,
    after: `${IMG}5426818dbb4a3a1d4555514c96558007a1658e98535b366c54a8cc139b7a1b3f.jpeg`,
  },
];

export const INSTAGRAM_URL = "https://www.instagram.com/stopcheni.ch";
export const COMPANY = { street: "Route de Crochy 20", npa: "1024", city: "Écublens", phone: "+41 79 514 82 45", tel: "+41795148245", email: "info@stopcheni.ch" };
